import { any, compose, equals } from 'ramda';

import { flattenGraphQLErrorCodes } from '../graphql/selectors';

/**
 * Determines if any of the graphql errors contain a duplicate membership
 * error code.
 *
 * @param {object} graphqlResponse - The graphql response object.
 * @returns {boolean} Whether or not any of the errors contain a requires
 * membership error.
 */
export const hasDuplicateMembershipError = compose(
  any(equals('duplicate-membership')),
  flattenGraphQLErrorCodes
);
